import ReportingBucketNavSwitch from '@app/components/LoggedIn/Menu/common/NavSwitch/ReportingBucketNavSwitch';

const EndOfShift = () => (
  <ReportingBucketNavSwitch bucket="endOfShiftReports" />
);

export default EndOfShift;
